import { DateTime } from 'luxon'

const ROOT_PATH = 'images/'

export const SIZES = {
    XXS: 'xxs',
    XS: 'xs',
    SM: 'xm',
    MD: 'md',
    LG: 'lg',
    FULL: 'full'
}

const sizes = {
    [SIZES.XXS]: 100, // Icons / Map Markers
    [SIZES.XS]: 200,  // Thumbnails
    [SIZES.SM]: 500,  // Big thumbnails
    [SIZES.MD]: 1000, // Gallery
    [SIZES.LG]: 2000  // Photoswipe
}

// TODO: fetch exact images rather than using dynamic resizing
// const new_sizes = {
//     [SIZES.XXS]: 120, // Icons / Map Markers
//     [SIZES.XS]: 360,  // Thumbnails
//     [SIZES.SM]: 720,  // Big thumbnails
//     [SIZES.MD]: 1080, // Gallery
//     [SIZES.LG]: 2160  // Photoswipe
// }


function generateSizes(src, fullWidth, fullHeight) {
    return Object.fromEntries(
        Object.values(SIZES).map(size => generateSize(size, src, fullWidth, fullHeight))
    )
}

function generateSize(size, originalSrc, fullWidth, fullHeight) {
    if (size === 'full') return ['full', { src: originalSrc, width: fullWidth, height: fullHeight }]

    const width = sizes[size]
    const height = Math.round(fullHeight * (width / fullWidth))
    const src = `${originalSrc}?nf_resize=fit&w=${width}`

    return [size, { src, width, height }]
}

export default class Image {
    constructor(data) {
        const { src, width, height, alt, timezone, timeUTC, credit = '' } = data
        this.width = width
        this.height = height

        const absoluteSrc = src.startsWith('https://')
        this.originalSrc = absoluteSrc ? src : ROOT_PATH + src
        this.src = absoluteSrc ? src : this.originalSrc + "?nf_resize=fit&w=1000"
        this.sizes = generateSizes(this.originalSrc, width, height)
        this.srcset = Object.values(this.sizes).map(({ width, src }) => `${src} ${width}w`).join(', ')
        this.alt = alt

        this.credit = credit

        // TODO: use when instead of timeUTC/timeLocal
        this.timeUTC = DateTime.fromISO(timeUTC)
        this.timeLocal = this.timeUTC.setZone({ zone: timezone }) // TODO: is this how setZone works?
    }

    getSize(sizeName) {
        const size = this.sizes[sizeName]
        if (!size) return this.sizes[SIZES.MD]
        return (this.width < size.width) ? this.sizes.full : size
    }

    static fromJson(json) {
        return new Image({
            id: json.id,
            src: json.src,
            width: json.width,
            height: json.height,
            credit: json.author,
            alt: json.caption,
            timezone: json.when ? json.when.timezone : null,
            timeLocal: json.when ? (json.when.interval || json.when.start) : null
        })
    }
}
